import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'button-editar-pessoa-fisica',
  templateUrl: './button-editar.component.html',
  styleUrls: ['./button-editar.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class ButtonEditarComponent implements OnInit {

  formGroup: FormGroup;

  constructor(
    private _controlContainer: ControlContainer
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
  }

  edit() {
    if (this.formGroup.enabled) {
      this.formGroup.disable({ emitEvent: false });
    } else {
      this.formGroup.enable({ emitEvent: false });
      this.formGroup.get("stConcessionarioPessoa").disable({ emitEvent: false })
      this.formGroup.markAllAsTouched();
    }
  }
}
